import { Location } from '@angular/common';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

import { Router } from '@angular/router';
import { User } from 'src/app/domain/user';
import { ENavigationRoute } from 'src/app/model/enum/navigation-route';
import { UserService } from 'src/app/services/user.service';
import { CoreData } from 'src/app/tools/core-data/core-data';
import { NotificationManager } from 'src/app/tools/ui/notification-manager';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LoginComponent implements OnInit {

    public User: User = new User;
    public IsPasswordVisible = false;
    public ShowResetForm = false;

    constructor(
        private snackBar: MatSnackBar,
        private coreData: CoreData,
        private userService: UserService,
        private location: Location,
        private router: Router) { }

    ngOnInit() {
        this.coreData.WithOauth2 = false;
        if (this.coreData.IsLoggedIn) {
            this.router.navigate([ENavigationRoute.Home]);
        }
    }

    public tryCredentials() {
        if (this.User.Email && this.User.Password) {
            const user = Object.assign({}, this.User);
            this.userService.tryCredential(user).subscribe(x => {
                this.coreData.Token = x;

                if (window.history.length > 1) {
                    this.location.back();
                } else {
                    this.router.navigate([ENavigationRoute.Home]);
                }
            }, error => {
                this.User = new User();
            });
        }
    }

    resetPassword() {
        this.userService.askForResetPassword(this.User.Email).subscribe(x => {
            if (x) {
                NotificationManager.handleSuccess('Un email de réinitialisation de mot de passe vous a été envoyé', this.snackBar);
            }
        });
    }

    askForAccess() {
        this.userService.askForAccess(this.User).subscribe(x => {
            if (x) {
                NotificationManager.handleSuccess('Votre demande d\'accès a bien été prise en compte. Vous allez recevoir un email sous peu.', this.snackBar);
            }
        });
    }
}
